import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import { rules } from "./rules";
import { hasLeadershipConstant } from "../Listing/constant";
import React from "react";

/**
 * Renders the form component for EducationTraining.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.form - The form instance.
 * @param {number} props.id - The ID of the form.
 * @param {Function} props.handleSubmit - The function to handle form submission.
 * @param {Function} props.onValuesChange - The function to handle form values change.
 * @param {Object} props.editValues - The values to be edited.
 * @return {JSX.Element} The rendered form component.
 */
const FormComponent: React.FC<any> = ({
  form,
  id,
  handleSubmit,
  onValuesChange,
  editValues,
}) => {
  const [hasLeadershipCheck, setHasLeadershipCheck] = useState(0);

  useEffect(() => {
    if (editValues) {
      const hasLeadership = hasLeadershipConstant.find(
        (data: any) => data.name === editValues?.has_leadership
      )?.id;
      form.setFieldsValue({
        ...editValues,
        has_leadership: hasLeadership === 1 ? [1] : [],
      });
      setHasLeadershipCheck(hasLeadership === 1 ? 1 : 0);

    }
  }, [editValues, form]);

  /**
   * Handles the form submission and dispatches the createRecord action.
   */
  const onFinish = (data: any) => {
    const formData = { ...data, has_leadership: hasLeadershipCheck };
    handleSubmit(formData);
  };
  return (
    <>
      <FormBox
        form={form}
        id={id}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
      >
        <Row gutter={15}>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Text
              required
              name="name"
              label="Name"
              rules={rules.name()}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }} style={{ marginTop: 35 }}>
            <InputBox.Checkbox
              noStyle
              name="has_leadership"
              options={{
                list: [
                  {
                    id: 1,
                    name: "Has Leadership?",
                  },
                ],
              }}
              onChange={(e: any) => {
                form.validateFields();
                setHasLeadershipCheck(e[0] === undefined ? 0 : 1);
              }}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Number
              required
              type="number"
              label="High School Diploma Or Ged"
              name="high_school_diploma_or_ged"
              minValue={0}
              maxValue={100}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Number
              required
              type="number"
              label="Associate Degree"
              name="associate_degree"
              minValue={0}
              maxValue={100}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Number
              required
              type="number"
              label="Bachelors Degree"
              name="bachelors_degree"
              minValue={0}
              maxValue={100}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Number
              required
              type="number"
              label="Masters Degree"
              name="masters_degree"
              minValue={0}
              maxValue={100}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Number
              required
              type="number"
              label="Pre Apprenticeship"
              name="pre_apprenticeship"
              minValue={0}
              maxValue={100}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Number
              required
              type="number"
              label="Apprenticeship"
              name="apprenticeship"
              minValue={0}
              maxValue={100}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Number
              required
              type="number"
              label="Not Available"
              name="not_available"
              minValue={0}
              maxValue={100}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Number
              required
              type="number"
              label="Doctoral Degree"
              name="doctoral_degree"
              minValue={0}
              maxValue={100}
            />
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default FormComponent;
